import React, { Component, Suspense } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Button, ButtonGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";

import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import { closeCustomModal, openCustomModal } from "components/custom/modals";
import {
	fetchInterviewCategories,
	clearInterviewCategories,
	deleteInterviewCategory
} from "api/menu/hr/interview-categories/actions";

const CategoryModal = React.lazy(() => import("./category-modal"));

class InterviewCategoriesList extends Component {
	componentDidMount() {
		this.props.fetchInterviewCategories(false);
	}

	componentWillUnmount() {
		this.props.clearInterviewCategories();
	}

	openModal = (id = false) => {
		const modalTitle = id !== false ? "Update" : "Create";
		const modalObj = {
			id: `interview-category-${id}`,
			header: `${modalTitle} Interview Category`,
			modalSettings: { size: "md" },
			children: (
				<Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
					<CategoryModal
						categoryId={id}
						onCancel={() => this.props.closeCustomModal(modalObj)}
						onSaved={() => {
							this.props.fetchInterviewCategories(false);
							this.props.closeCustomModal(modalObj);
						}}
					/>
				</Suspense>
			),
			handleClose: () => this.props.closeCustomModal(modalObj)
		};
		this.props.openCustomModal(modalObj);
	};

	delete = (id, name) => {
		this.props.deleteInterviewCategory(id, name, () => this.props.fetchInterviewCategories(false));
	};

	render() {
		const { categories, loading } = this.props;
		const columns = [
			{ Header: "Name", accessor: "name", id: "name" },
			{
				Header: "Active",
				id: "isActive",
				accessor: original => (original.isActive ? "Yes" : "No"),
				Cell: ({ original }) => (original.isActive ? "Yes" : "No"),
				className: "d-flex justify-content-center align-items-center",
				Filter: ({ filter, onChange }) => (
					<ReactTableFilterSelect
						currentValue={filter ? filter.value : ""}
						onChange={value => onChange(value)}
						style={{ width: "100%", height: "100%" }}
						optionsObject={{ "": "Show All", YES: "Yes", NO: "No" }}
					/>
				)
			},
			{
				Header: "Actions",
				id: "actions",
				className: "d-flex justify-content-center align-items-center",
				Cell: ({ original }) => (
					<ButtonGroup>
						<Button size="sm" onClick={() => this.openModal(original.id)}>
							<FontAwesomeIcon icon="pen" title="Update" />
						</Button>
						<Popconfirm
							title={`Delete "${original.name}"?`}
							onConfirm={() => this.delete(original.id, original.name)}
							placement="bottomRight"
							okText="Yes"
							cancelText="Cancel"
						>
							<Button variant="danger" size="sm">
								<FontAwesomeIcon icon="times" />
							</Button>
						</Popconfirm>
					</ButtonGroup>
				),
				filterable: false,
				width: 100
			}
		];

		return (
			<div className="dashboard">
				<h3 className="mb-4 d-flex align-items-center">
					Interview Categories
					<Button className="ml-auto" variant="primary" onClick={() => this.openModal()}>
						Add Category
					</Button>
				</h3>
				<ReactTable
					data={categories}
					headerClassName="table-header"
					columns={columns}
					defaultPageSize={20}
					pageSizeOptions={[10, 20, 50]}
					resizable
					className="-striped -highlight"
					loading={loading}
					filterable
					defaultFilterMethod={filterCaseInsensitive}
					defaultSorted={[{ id: "name", desc: false }]}
					getNoDataProps={() => ({ style: { zIndex: 0 } })}
					style={{ height: "calc(100vh - 140px)" }}
				/>
			</div>
		);
	}
}

InterviewCategoriesList.propTypes = {
	categories: PropTypes.array.isRequired,
	loading: PropTypes.bool.isRequired,
	fetchInterviewCategories: PropTypes.func.isRequired,
	clearInterviewCategories: PropTypes.func.isRequired,
	deleteInterviewCategory: PropTypes.func.isRequired,
	openCustomModal: PropTypes.func.isRequired,
	closeCustomModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	categories: state.interviewCategories.categories,
	loading: state.interviewCategories.loading
});

const mapDispatchToProps = dispatch => ({
	fetchInterviewCategories: bindActionCreators(fetchInterviewCategories, dispatch),
	clearInterviewCategories: bindActionCreators(clearInterviewCategories, dispatch),
	deleteInterviewCategory: bindActionCreators(deleteInterviewCategory, dispatch),
	openCustomModal: bindActionCreators(openCustomModal, dispatch),
	closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InterviewCategoriesList);
